import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import type { RootState } from "@/store";
import { type Theme, setTheme } from "@/store/slices/uiSlice";

export const useTheme = () => {
  const dispatch = useAppDispatch();
  const theme = useAppSelector((state: RootState) => state.ui.theme);

  const changeTheme = (newTheme: Theme) => {
    dispatch(setTheme(newTheme));
  };

  return {
    theme,
    setTheme: changeTheme,
  };
};
